<div [class]="containerClasses(level())" class="break-inside-avoid border-2!">
  <!-- Main grid layout: 2 equal columns -->
  <div class="grid grid-cols-2">
    <!-- Left: Star/Level Badge + Tire Info -->
    <div class="grid grid-cols-[auto_1fr]">
      <div [class]="background(level())" class="flex flex-col items-center justify-center font-semibold text-xl w-28 rounded-tl-sm">
        <div class="flex gap-0.5 mb-1">
          @for (star of stars(level()); track $index) {
            <app-icons icon="star"/>
          }
        </div>
        <div>{{ level() | uppercase }}</div>
      </div>

      <div class="flex items-center gap-3">
        <app-item-image [item]="item()" width="65" height="65" class="shrink-0"/>
        <div class="text-sm">
          <div class="font-semibold text-lg">{{ item().brand }}</div>
          <div>{{ item().model }} - {{ item().item_number }}</div>
          <div>{{ item().size }} {{ getFeatureString(item()) }}</div>
        </div>
      </div>
    </div>

    <!-- Right: Price/Warranty -->
    <div class="p-1 border-l-2" [class]="borderColor()">
      <div class="grid grid-cols-2 text-sm">
        <div>Price</div>
        <div class="text-right font-semibold">{{ price() | currency }} ea.</div>

        @if (item().features.mileage_warranty) {
          <div>Warranty</div>
          <div class="text-right font-semibold">{{ item().features.mileage_warranty }}</div>
        }
      </div>
    </div>
  </div>

  <!-- Second row: Subtotal/Options | Fees & Taxes -->
  <div class="grid grid-cols-2 border-t-2" [class]="borderColor()">
    <!-- Left side: Subtotal and Options -->
    <div>
      <div class="flex justify-between items-center px-3 py-1 font-semibold text-sm border-b-2 border-b-gray-200">
        <div>Subtotal</div>
        <div class="flex gap-6">
          <span class="text-gray-600 font-normal">Qty 4</span>
          <span>{{ subtotal() | currency }}</span>
        </div>
      </div>

      <div class="px-3 font-semibold text-sm py-1">Options</div>

      @if (addonForItem()?.addons?.length) {
        <div class="pl-6 text-sm">
          @for (addon of addonForItem()!.addons; track $index) {
            <div class="flex justify-between items-center px-3">
              <div>{{ addon.description }}</div>
              <div class="flex gap-6">
                <span class="text-gray-600">(per tire)</span>
                <span class="font-semibold">{{ addon.price_each | currency }}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="bg-gray-100">
      <div class="px-3 py-1 font-semibold text-sm">Fees & Taxes</div>

      <div class="pl-6 text-sm">
        @if (addonForItem()?.fees?.length) {
          @for (fee of addonForItem()!.fees; track fee.fee_id) {
            <div class="flex justify-between items-center px-3">
              <div>{{ fee.description }}</div>
              <div class="font-semibold">{{ fee.total | currency }}</div>
            </div>
          }
        }

        <div class="flex justify-between items-center px-3">
          <div>Sales Tax</div>
          <span class="font-semibold">{{ tax() | currency }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (item().customer_notes; as notes) {
    <div class="border-t-2 border-t-gray-200 px-3 py-1 text-sm whitespace-pre-line">
      <span class="font-semibold">Notes:</span> {{ notes }}
    </div>
  }

  <!-- Total row -->
  <div class="border-t-2 border-t-gray-200 px-3 py-1 flex justify-between items-center">
    <div class="text-xl font-bold">Total</div>
    <div class="text-2xl font-bold">{{ outTheDoorPricing() | currency }}</div>
  </div>
</div>
